import { Component, OnInit } from "@angular/core";
import { MatSlideToggleChange } from "@angular/material";
import { FormBuilder, FormGroup, Validators, ValidationErrors } from "@angular/forms";

import { ValidationService } from "../../../../common/validation/validation.service";
import { SdpIcon } from "../../../../common/icon/models";
import { AbstractWizardStepComponent } from "app/administrative/wizard-dialog/abstract-wizard-step.component";
import { GatewayEditIpPortsComponent } from "../gateway-edit-ip-ports/gateway-edit-ip-ports.component";
import { GatewayEditWizardService, PrivateGatewayEdit } from "../gateway-edit-wizard.service";
import { CrossFieldErrorMatcher } from "../cross-field-error-matcher";

@Component({
	selector: "sdp-gateway-edit-dns",
	templateUrl: "./gateway-edit-dns.component.html"
})
export class GatewayEditDnsComponent extends AbstractWizardStepComponent<PrivateGatewayEdit> implements OnInit {
	public form!: FormGroup;

	public helpIcon: SdpIcon.Icon = {
		name: "help",
		type: "material",
		cssClass: "sdp-device-list-item-info sdp-gateway-help-icon",
		toolTip: "privategateway.dns.help"
	};
	public dnsSuffixHelpIcon: SdpIcon.Icon = {
		name: "help",
		type: "material",
		cssClass: "sdp-device-list-item-info sdp-gateway-help-icon",
		toolTip: "privategateway.dns.suffix.help"
	};

	public dnsServerMatcher = new CrossFieldErrorMatcher(["valuesAreSame"]);

	constructor(
		private formBuilder: FormBuilder,
		private validationService: ValidationService,
		private service: GatewayEditWizardService
	) {
		super();
	}

	public ngOnInit() {
		const formValidators: ValidationErrors[] = [
			this.validationService.validateIfEqual("dnsEnabled", true, this.validationService.valuesCannotBetheSame("dnsServer1", "dnsServer2"))
		];
		this.form = this.formBuilder.group(
			{
				dnsEnabled: [
					this.data.editGateway.dnsEnabled
				],
				dnsServer1: [
					this.data.editGateway.dnsServer1,
					Validators.compose([
						Validators.required,
						this.validationService.singleIp
					])],
				dnsServer2: [
					this.data.editGateway.dnsServer2,
					this.validationService.singleIp
				],
				dnsSuffixEnabled: [
					this.data.editGateway.dnsSuffixEnabled
				],
				dnsSuffix: [
					this.data.editGateway.dnsSuffix,
					Validators.compose([
						Validators.required,
						this.validationService.domainSuffix
					])
				]
			},
			{
				validators: formValidators
			}
		);

		if (!this.data.editGateway.dnsEnabled) {
			this.form.controls["dnsServer1"].disable();
			this.form.controls["dnsServer2"].disable();
		}

		if (!this.data.editGateway.dnsSuffixEnabled) {
			this.form.controls["dnsSuffix"].disable();
		}
	}

	public get title() {
		return "gateway.edit.title";
	}

	public get description() {
		return "gateway.edit.dns.description";
	}

	public get nextStep(): AbstractWizardStepComponent.ConstructorFunction<PrivateGatewayEdit> | undefined {
		return undefined;
	}

	public get previousStep(): AbstractWizardStepComponent.ConstructorFunction<PrivateGatewayEdit> | undefined {
		return GatewayEditIpPortsComponent;
	}

	public get isFormValid() {
		return !this.form || this.form.valid;
	}

	public performPrevious() {
		this.service.processDns(this.form.getRawValue());
	}

	public async performNext() {
		this.service.processDns(this.form.getRawValue());
		await this.service.processGateway();
	}

	public get showProgressBar() {
		return false;
	}

	public toggleDnsEnabled(event: MatSlideToggleChange) {
		if (event.checked) {
			this.form.controls["dnsServer1"].enable();
			this.form.controls["dnsServer2"].enable();
		} else {
			this.form.controls["dnsServer1"].disable();
			this.form.controls["dnsServer2"].disable();
		}
	}

	public get dnsEnabled() {
		return this.form.getRawValue().dnsEnabled;
	}

	public toggleDnsSuffixEnabled(event: MatSlideToggleChange) {
		if (event.checked) {
			this.form.controls["dnsSuffix"].enable();
		} else {
			this.form.controls["dnsSuffix"].disable();
		}
	}
}
